import { featureFlags } from 'client/store/modules/FeatureFlagsModule';
import { passwordManagerTabs } from 'client/PasswordManager/PasswordManagerConstants';
import { trialPropsData } from 'client/util/Constants/FeatureTrialConstants';

const PasswordManagerMainPanel = () => import('client/PasswordManager/PasswordManagerMainPanel.vue');
const PasswordManagerSharedFolderDetails = () => import('client/PasswordManager/PasswordManagerSharedFolderDetails.vue');
const PasswordManagerUserDetails = () => import('client/PasswordManager/PasswordManagerUserDetails.vue');

const metaData = {
  loadLegacyStyles: false,
  title: 'Password Manager',
  feature: trialPropsData.passwordManagement.featureCode,
  defaultPremiumBadgeVisibility: true,
  modalProps: trialPropsData.passwordManagement,
};

const bindReturnPathToPreviousRoute = (to, from, next) => {
  if (!from?.path) {
    next();
  } else {
    const toRoute = to;

    if (!toRoute.meta) {
      toRoute.meta = {};
    }
    toRoute.meta.returnPath = from.path;
    next();
  }
};

const beforeEnter = (enabledFlags) => (to, from, next) => {
  const showRoute = !!enabledFlags[featureFlags.passwordManager];
  if (showRoute) {
    next();
  } else {
    // If coming from outside JC, route to the home page, else go to previous
    const redirect = from.path === '/' ? { path: '/home' } : from;
    next(redirect);
  }
};

export default (enabledFlags) => [
  {
    path: '/passwordmanager',
    name: 'passwordManager',
    meta: metaData,

    components: {
      mainPanel: PasswordManagerMainPanel,
    },

    props: {
      mainPanel: {
        activeTab: passwordManagerTabs.overview,
      },
    },

    beforeEnter: beforeEnter(enabledFlags),
  },

  {
    path: '/passwordmanager/overview',
    name: 'passwordManagerOverview',
    meta: metaData,

    components: {
      mainPanel: PasswordManagerMainPanel,
    },

    props: {
      mainPanel: {
        activeTab: passwordManagerTabs.overview,
      },
    },

    beforeEnter: beforeEnter(enabledFlags),
  },

  {
    path: '/passwordmanager/sharedfolders',
    name: 'passwordManagerSharedFolders',
    meta: metaData,

    components: {
      mainPanel: PasswordManagerMainPanel,
    },

    props: {
      mainPanel: {
        activeTab: passwordManagerTabs.sharedFolders,
      },
    },

    beforeEnter: beforeEnter(enabledFlags),
  },

  {
    path: '/passwordmanager/sharedfolders/:id/details',
    name: 'passwordManagerSharedFolder',
    meta: {
      ...metaData,
      returnPath: '/passwordmanager/sharedfolders',
    },

    components: {
      mainPanel: PasswordManagerSharedFolderDetails,
    },

    props: {
      mainPanel: route => ({
        sharedFolderId: route.params.id,
      }),
    },

    beforeEnter: beforeEnter(enabledFlags),
  },

  {
    path: '/passwordmanager/users',
    name: 'passwordManagerUsers',
    meta: metaData,

    components: {
      mainPanel: PasswordManagerMainPanel,
    },

    props: {
      mainPanel: {
        activeTab: passwordManagerTabs.users,
      },
    },

    beforeEnter: beforeEnter(enabledFlags),
  },

  {
    path: '/passwordmanager/users/:id/details',
    name: 'passwordManagerUser',
    meta: {
      ...metaData,
      returnPath: '/passwordmanager/users',
    },

    components: {
      mainPanel: PasswordManagerUserDetails,
    },

    props: {
      mainPanel: route => ({
        userId: route.params.id,
      }),
    },

    beforeEnter: (to, from, next) => {
      const showRoute = !!enabledFlags[featureFlags.passwordManager];
      if (showRoute) {
        bindReturnPathToPreviousRoute(to, from, next);
      } else {
        // If coming from outside JC, route to the home page, else go to previous
        const redirect = from.path === '/' ? { path: '/home' } : from;
        next(redirect);
      }
    },
  },

  {
    path: '/passwordmanager/settings',
    name: 'passwordManagerSettings',
    meta: metaData,

    components: {
      mainPanel: PasswordManagerMainPanel,
    },

    props: {
      mainPanel: {
        activeTab: passwordManagerTabs.settings,
      },
    },

    beforeEnter: beforeEnter(enabledFlags),
  },
];
